module.exports = __webpack_public_path__ + "static/media/logoA.b9703db7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logoA.jpg
// module id = 2706
// module chunks = 2